import { createFileRoute } from "@tanstack/react-router";
import { AdminMembershipsView } from "@/components/admin/AdminMembershipsView";

export const Route = createFileRoute("/_authenticated/admin/memberships")({
  head: () => ({ meta: [{ title: "Memberships — Admin" }] }),
  component: AdminMembershipsPage,
});

function AdminMembershipsPage() {
  return <AdminMembershipsView />;
}
